import { useEffect } from 'react';

// Reference count and originals preserved across multiple locks
let scrollLockCount = 0;
let savedOverflow: string = '';
let savedPaddingRight: string = '';

/**
 * Hook to lock body scroll when modal/popup is open
 * Uses a reference-count so multiple callers can request a lock safely
 */
export function useScrollLock(isLocked: boolean) {
  useEffect(() => {
    if (!isLocked) return;

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    let savedHtmlOverflow: string = '';
    let savedBodyOverflow: string = '';
    let savedBodyPaddingRight: string = '';
    
    // First locker saves originals and applies lock
    if (scrollLockCount === 0) {
      // Save original styles
      savedBodyOverflow = document.body.style.overflow;
      savedBodyPaddingRight = document.body.style.paddingRight;
      savedHtmlOverflow = document.documentElement.style.overflow;
      
      // Lock both html and body to prevent all scrolling
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      
      // Compensate for scrollbar width to prevent layout shift
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      }
    }

    scrollLockCount++;

    return () => {
      scrollLockCount = Math.max(0, scrollLockCount - 1);
      // Only restore when last locker releases
      if (scrollLockCount === 0) {
        document.documentElement.style.overflow = savedHtmlOverflow;
        document.body.style.overflow = savedBodyOverflow;
        document.body.style.paddingRight = savedBodyPaddingRight;
      }
    };
  }, [isLocked]);
}

